import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { IncidentsComponent } from "../../sections/incidents/incidents.component";

const routes: Routes = [
  {
    path: "",
    component: IncidentsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IncidentsRouterModule {}
